module.exports = __webpack_public_path__ + "static/media/weather-dashboard.16cfa71d.png";